import React from "react";
import { Box, RadioGroup } from "@mui/material";
import CommonRadio from "../../../CommonComponents/CommonRadio/CommonRadio";
import FieldError from "./FieldError";
import styles from "../AddVendorModal.module.css";

import {
  radioSx,
  radioLabelSx,
  specialisedRadioGroupSx,
} from "../AddVendorModal.styles";

const SpecialisedField = ({ value, onChange, error }) => (
  <Box className={styles.fieldWrapper}>
    <p className={styles.fieldLabel}>
      Specialised <span className={styles.requiredStar}>*</span>
    </p>

    <RadioGroup
      row
      name="specialised"
      value={value}
      onChange={onChange}
      sx={specialisedRadioGroupSx}
    >
      <CommonRadio
        value="yes"
        label="Yes"
        name="specialised"
        radioSx={radioSx}
        sx={radioLabelSx}
      />

      <CommonRadio
        value="no"
        label="No"
        name="specialised"
        radioSx={radioSx}
        sx={radioLabelSx}
      />
    </RadioGroup>

    <FieldError error={error} />
  </Box>
);

export default SpecialisedField;
